import { z } from "zod";

import { lenient, propertyFilterSearch } from "./search.ts";

// WHY: plain text here keeps the Costs views, states and sorts out of the first load; costs/costs-search.ts reads them. `invoice` opens one invoice (an unusual-bill alert).
const costsText = lenient(z.string().max(32));

export const costsSearch = propertyFilterSearch.extend({
  view: costsText,
  year: lenient(z.int().min(1900).max(2099)),
  month: lenient(z.int().min(1).max(12)),
  category: lenient(z.string().max(36)),
  contract: lenient(z.uuid()),
  vendor: lenient(z.uuid()),
  state: costsText,
  finding: lenient(z.literal("open")),
  sort: costsText,
  basis: lenient(z.literal("paid")),
  by: lenient(z.literal("month")),
  property: lenient(z.uuid()),
  invoice: lenient(z.uuid()),
  create: lenient(z.enum(["invoice", "cost"])),
});

export type CostsSearch = z.infer<typeof costsSearch>;
